module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules02-e5135b0aefe593512d45f8f5289b97d8.png";